import axios from 'axios';

const basePath = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const http = axios.create({
    baseURL: `${basePath}/api`
});

// The interceptor will be initialized when the app starts with a function to get the token
let getTokenFn: (() => string | null) | null = null;

export const setGetTokenFn = (fn: () => string | null) => {
    getTokenFn = fn;
};

http.interceptors.request.use((config) => {
    const token = getTokenFn ? getTokenFn() : null;
    if (token) {
        config.headers = config.headers || {};
        (config.headers as any).Authorization = `Bearer ${token}`;
    }
    return config;
});

// Global 401 handler: redirect to login when the backend responds with 401
http.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        if (status === 401) {
            // In OIDC, we usually let the library handle session expiration
            // but we can trigger a re-login if needed.
            if (typeof window !== 'undefined') {
                window.location.assign(`${basePath}/login`);
            }
        }
        return Promise.reject(error);
    }
);

export default http;
